import React from 'react'

export default function DFSearchInput({ value, onChange, placeholder = 'Search...' }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        background: 'var(--df-surface-2)',
        borderRadius: 'var(--df-radius-sm, 6px)',
        padding: '0 10px',
        height: 36,
      }}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="var(--df-ink-4, #97a094)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ flexShrink: 0 }}
      >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{
          flex: 1,
          border: 'none',
          background: 'transparent',
          outline: 'none',
          fontSize: 13,
          fontFamily: 'inherit',
          color: 'var(--df-ink)',
          lineHeight: 1.4,
        }}
      />
    </div>
  )
}
